/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_UserInputs */

const en_page_title_user = /** @type {(inputs: Page_Title_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const nl_page_title_user = /** @type {(inputs: Page_Title_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruiker`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Page_Title_UserInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_user = /** @type {((inputs?: Page_Title_UserInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_UserInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_user(inputs)
	return en_page_title_user(inputs)
});